import { render, staticRenderFns } from "./regulatory.vue?vue&type=template&id=10087af4&"
import script from "./regulatory.vue?vue&type=script&lang=js&"
export * from "./regulatory.vue?vue&type=script&lang=js&"
import style0 from "./regulatory.vue?vue&type=style&index=0&id=10087af4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports